<app-sidenav>
    <mat-progress-bar
        mode="query"
        color="accent"
        *ngIf="showLoading | async"
    ></mat-progress-bar>
    <router-outlet></router-outlet>
</app-sidenav>